import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ModuleHead from '../../components/moduleHead';
import ModuleFeed from '../../components/moduleFeed';

class Research extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { researchHead, researchBref, researchData } = this.props.content;

        return (
            <div className={styles.news}>
                <Chip id="260638" type="struct" title="风暴眼标题" groupName="上市公司研究院" content={researchHead}>
                    <ModuleHead />
                </Chip>
                <ModuleFeed bref={researchBref} lists={researchData} title="上市公司研究院" brefId="260649" />
            </div>
        );
    }
}

export default errorBoundary(Research);
